import {CsRandom} from "../../scripts/utils/cs-random";
import {CsTemplateHelper} from "../../scripts/utils/cs-template-helper";

class CsBaseComponent extends HTMLElement {
    protected elementId: string;

    constructor() {
        super();
        this.elementId = CsRandom.generateId();
    }

    connectedCallback() {
        this.render();
        this.addEventListeners();
    }

    attributeChangedCallback() {
        this.render();
    }

    addEventListeners() {}

    render() {
        const template = this.getTemplate();
        this.innerHTML = CsTemplateHelper.applyTemplate(template, this, this.elementId);
        this.applyStyles();
    }

    getTemplate(): string {
        return '';
    }

    applyStyles() {}
}

export {CsBaseComponent};